import { render, staticRenderFns } from "./AddLinks.vue?vue&type=template&id=6c53bb26&"
import script from "./AddLinks.vue?vue&type=script&lang=js&"
export * from "./AddLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports